var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{staticClass:"text-center",attrs:{"dense":"","label":_vm.label,"g-mask":_vm.isConfigReady ? _vm.currentMask : {
    mask: 'XXXXXX',
    tokens: {
      X: {
        pattern: /(?![aeiouAEIOU])[A-Za-z0-9]/,
        transform: 'toUpperCase',
      },
    },
  },"rules":_vm.internalRules,"error-messages":_vm.errorMessages},on:{"blur":function($event){return _vm.$emit('blur', $event)}},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }